export default class SearchAddress {
    constructor() {
        this.autocompleteService = new google.maps.places.AutocompleteService();
    }

    search(token, term, onResult) {

        if (!term) {
            return;
        }

        const params = {
            componentRestrictions: {
                country: 'it'
            },
            input: term,
            types: ['address'],
            sessionToken: token
        };

        this.autocompleteService.getPlacePredictions(params, (predictions, status) => {
            if (typeof onResult === 'function') {
                if (status === 'OK') {
                    let results = predictions.map((prediction) => {
                        return {
                            description: prediction.description,
                            placeId: prediction.place_id
                        }
                    });

                    onResult(results);
                } else {
                    onResult([]);
                }
            }
        })

    }
}